import {container, primaryColor, secondaryColor, title} from "../../nextjs-material-kit.js";
import {insetLogoSize} from "../const";

const employersStyle = (theme) => ({
  container: {
    zIndex: "12",
    color: "#ffffff",
    height: "auto",
    margin: "0 auto !important",
    marginBottom: "0",
    justifyContent: "center",
    ...container(theme),
  },
  fullMaxWidth: {
    "@media (max-width: 768px)": {
      maxWidth: "100% !important",
    },
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px !important",
    minHeight: "32px",
    color: "#FFFFFF",
    textDecoration: "none",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    fontSize: "5.5em",
    left: "50%",
    transform: "translateX(-50%)",
  },
  title_cap: {
    marginTop: "30px !important",
  },
  employerCardOuter: {
    paddingRight: "6px",
    paddingLeft: "6px",

    a: {
      textDecoration: "none",
    },
  },
  employerCard: {
    borderRadius: "0",
    boxShadow: "none",
    border: "1px solid " + primaryColor,
    cursor: "pointer",
    marginBottom: "13px !important",
  },
  cardLogoContainer: {
    minHeight: insetLogoSize,
    // Approximately match Home's blue box surround, which has 10px padding but also a
    // height minimum adding another ~10px.
    padding: "20px",
    backgroundColor: "#eaf6fe",
  },
  cardLogo: {
    // `backgroundImage` to be set dynamically inline.
    minHeight: insetLogoSize,
    backgroundPosition: "center",
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
  },
  cardTitle: {
    color: "#095a70",
    fontFamily: "var(--font-brandon-grotesque)",
    fontWeight: 900,
    fontSize: "16px",
  },
  cardDesc: {
    color: primaryColor,
  },
  cardSubTitle: {
    marginTop: "0",
    color: "#000",
    fontFamily: "var(--font-brandon-grotesque)",
    textAlign: "center",
  },
  search_section: {
    padding: "20px 30px",
  },
  bg_colored: {
    backgroundColor: "#eaf6fe",
  },
  darkBlue: {
    backgroundColor: primaryColor,
  },
  white_bg: {
    background: "#ffffff",
  },
});

export default employersStyle;
